import React, { useEffect, useState } from "react";
import SuccessModal from "../SuccessModal";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import { postCustomerOrderChargesAdd } from "../../services/OrderEdit/orderInfoEdit";
import { Dropdown } from "primereact/dropdown";
import { getCustomerSingleOrderInfo } from "../../services/OrdersAPI/Orders";
import { getLocalChargesAndDiscount, getStoreLocalData } from "../../utils/localStorage";
import { getChargesAndDiscount } from "../../services/Cart/getChargesAndDiscount";

const BookingInfoDiscountsAdd = ({
  bookingInfoChargesAddModalVisible,
  setBookingInfoChargesAddModalVisible,
  sendDataToBookingInfoChargesAdd,
  storeCustomerId,
  bookingOrderId,
  storeId,
  discountData,
  userRole,
}) => {
  const [customDiscountTypeValue, setCustomDiscountTypeValue] = useState("");

  const [discounts, setDiscounts] = useState([]);
  const [addDiscountsValue, setAddDiscountsValue] = useState("");
  const [selectedDiscountsValue, setSelectedDiscountsValue] = useState({});
  const [selectedDiscountAmount, setSelectedDiscountAmount] = useState("");

  const { storeLocalData } = getStoreLocalData();
  const [customerOrdersData, setCustomerOrdersData] = useState([]);

  const fetchCustomerSingleOrder = () => {
    // getCustomerSingleOrder(storeCustomerId, storeId, bookingOrderId)
    getCustomerSingleOrderInfo(storeCustomerId, storeId, bookingOrderId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setCustomerOrdersData(Res);
        }
      })
      .catch((err) => {
        console.error("getCustomerSingleOrder Error:", err);
      });
  };

  const getChargeDiscountSymbol = (type) => {
    switch (type) {
      case "AMOUNT":
        return storeLocalData?.currencySymbol; // You can use any symbol you prefer for Amount
      case "PERCENTAGE":
        return "%"; // Use '%' symbol for PERCENTAGE
      default:
        return "";
    }
  };

  const fetchStoreChargesAndDiscount = async () => {
    try {
      const response = await getChargesAndDiscount(storeId);
      if (!response.data.error) {
        const Res = response.data;
       const [discountArray] = Res.reduce(
         ([discounts], item) => {
           if (
             item.chargeDiscountMode === "ALL" ||
             item.chargeDiscountMode === "BOOKING"
           ) {
             if (item.chargeDiscountType === "DISCOUNT") discounts.push(item);
           }
           return [discounts];
         },
         [[], []]
       );

        setDiscounts(discountArray);
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  const fetchLocalChargesAndDiscount = async () => {
    const { chargesAndDiscount } = getLocalChargesAndDiscount();
    if (chargesAndDiscount && Object.keys(chargesAndDiscount).length > 0) {
      const [discountArray] = chargesAndDiscount.reduce(
        ([discounts], item) => {
          if (
            item.chargeDiscountMode === "ALL" ||
            item.chargeDiscountMode === "BOOKING"
          ) {
            if (item.chargeDiscountType === "DISCOUNT") discounts.push(item);
          }
          return [discounts];
        },
        [[], []]
      );

      setDiscounts(discountArray);
    } else {
      setDiscounts([]);
    }
  };

  useEffect(() => {
    fetchCustomerSingleOrder();
    if(userRole=== "BY_STORE") {
      fetchLocalChargesAndDiscount();
    } else {
      fetchStoreChargesAndDiscount();
    }
  }, []);

  const addChargesData = discounts.map((item, index) => ({
    id: index + 1,
    chargeDiscountId: item.id,
    name:
      item.name +
      " | " +
      item.chargeDiscount +
      " | " +
      getChargeDiscountSymbol(item.chargeDiscountTypeIn),
    amount: item.chargeDiscount,
    chargeDiscountType: item.chargeDiscountType,
    chargeDiscountTypeIn: item.chargeDiscountTypeIn,
    description: item.description,
    orderChargeDiscountMode: item.chargeDiscountMode,
  }));

  const dropdownItems = addChargesData.filter(
    (discount) =>
      !discountData.some(
        (selectedCharge) =>
          selectedCharge.chargeDiscountId === discount.chargeDiscountId
      )
  );
  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [errorText, setErrorText] = useState("");

  const [isSubmitButtonPressed, setIsSubmitButtonPressed] = useState(false);
  const [showUpdateButton, setShowUpdateButton] = useState(false);

  const handleAddDiscountChange = (discount) => {
    let newDiscountAmount;
    if (discount.chargeDiscountTypeIn === "PERCENTAGE") {
      newDiscountAmount = Math.round(
        (customerOrdersData.grandTotal * discount.amount) / 100
      );
    } else {
      newDiscountAmount = Math.round(discount.amount);
    }
    setAddDiscountsValue(discount);
    setSelectedDiscountAmount(newDiscountAmount);
    setCustomDiscountTypeValue(discount.chargeDiscountTypeIn);
    setSelectedDiscountsValue(discount);
    if (customerOrdersData.grandTotal > newDiscountAmount) {
      setErrorText("");
      setIsSubmitButtonPressed(false);
    } else {
      setErrorText(
        "Discount Can Not Be Added Because Selected Discount Amount Is Greater Than Order Amount"
      );
      setIsSubmitButtonPressed(true);
    }
  };

  const handleDiscountAmountChange = (text) => {
    if (!text) {
      setSelectedDiscountAmount("");
      setErrorText("Total cannot be empty or zero");
      setIsSubmitButtonPressed(true);
    } else {
      if (text > customerOrdersData.grandTotal) {
        setSelectedDiscountAmount("");
        setErrorText(
          "Discount cannot be Greater Than " + customerOrdersData.grandTotal
        );
        setIsSubmitButtonPressed(false);
      } else {
        setSelectedDiscountAmount(text);
        setErrorText("");
        setIsSubmitButtonPressed(false);
      }
    }
  };

  const handleConfirmation = () => {
    if (!errorText) {
      setIsSubmitButtonPressed(true);
      const data = {
        ...selectedDiscountsValue,
        amount: parseInt(selectedDiscountAmount),
        count: 1,
        chargeDiscountAmount: parseInt(selectedDiscountsValue.amount),
      };

      postCustomerOrderChargesAdd(
        storeCustomerId,
        storeId,
        bookingOrderId,
        data
      )
        .then((response) => {
          if (!response.data.error) {
            const Res = response.data;
            const message = Res.message;
            const status = Res.status;
            sendDataToBookingInfoChargesAdd({
              success: status,
            });
            if (status === true) {
              setModalVisible(true);
              setModalStatus("success");
              setModalText(message);
            } else {
              setModalVisible(true);
              setModalStatus("not Success");
              setModalText(message);
            }
            setIsSubmitButtonPressed(false);
            setBookingInfoChargesAddModalVisible(false);
            setAddDiscountsValue("");
            setSelectedDiscountAmount("");
          }
        })
        .catch((err) => {
          console.error("Error:", err);
        });
    }
    setShowUpdateButton(true);
  };

  const handleModalClose = () => {
    setIsSubmitButtonPressed(false);
    setBookingInfoChargesAddModalVisible(false);
    setErrorText("");
    setAddDiscountsValue("");
    setSelectedDiscountAmount("");
    setShowUpdateButton(false);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={bookingInfoChargesAddModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!bookingInfoChargesAddModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div>
              <div
                className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
                style={{
                  backgroundImage:
                    "radial-gradient(circle at left top, #2B70D7, #1752AA)",
                }}
              >
                <div></div>

                <p className=" text-4xl text-primary-50 font-semibold">
                  Add Discount
                </p>
                <Button
                  label="x"
                  onClick={(e) => hide(e)}
                  text
                  className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
                ></Button>
              </div>

              <div className="flex-1 mx-4 mb-1 mt-3">
                <div
                  className="border-round-xl shadow-2"
                  style={{
                    backgroundColor: "#fff",
                  }}
                >
                  <Dropdown
                    value={addDiscountsValue}
                    onChange={(e) => handleAddDiscountChange(e.value)}
                    options={dropdownItems}
                    optionLabel="name"
                    placeholder="Add Discount"
                    className="w-full  bg-white-alpha-20  text-2xl text-primary-50"
                  />
                </div>
              </div>
              {addDiscountsValue && (
                <div className="mx-4 mt-3">
                  <div className="flex mt-1 mb-2 mx-1">
                    <div className="flex flex-row">
                      <p
                        className=" text-xl font-semibold"
                        style={{ alignSelf: "center" }}
                      >
                        Discount
                      </p>
                    </div>
                    <div className="flex flex-row gap-4">
                      <div className="border-round-xl shadow-4">
                        <InputText
                          placeholder="Discount"
                          value={selectedDiscountAmount}
                          maxLength={50}
                          onChange={(e) =>
                            handleDiscountAmountChange(e.target.value)
                          }
                          className="w-full border-none px-3 text-md "
                          disabled={
                            customDiscountTypeValue === "PERCENTAGE"
                              ? true
                              : false
                          }
                        ></InputText>
                      </div>
                    </div>
                  </div>

                  {errorText && (
                    <div
                      style={{
                        marginTop: 2,
                        marginBottom: 10,
                        marginRight: 20,
                        alignSelf: "center",
                      }}
                    >
                      <p style={{ color: "red" }}>{errorText}</p>
                    </div>
                  )}
                </div>
              )}
            </div>

            <Button
              disabled={
                selectedDiscountAmount === "" ? true : isSubmitButtonPressed
              }
              onClick={handleConfirmation}
              className="mt-1 mb-3 mx-4 border-round-xl "
            >
              <p className=" w-full text-2xl font-semibold flex justify-content-center">
                ADD
              </p>
            </Button>
          </div>
        )}
      ></Dialog>
      <SuccessModal
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        status={modalStatus}
        text={modalText}
      />
    </div>
  );
};

export default BookingInfoDiscountsAdd;
